// 繰出位牌かどうかの判定について
// 「.kuridashi-ihai」は butsudan.options メタフィールドの値でもあり、
// オプションアプリ側の各オプションにも同じクラスが付く（テーマが hidden を外すために使う）。
// クラス名だけで判定するとオプション項目にも反応してしまうため、
// シミュレータ本体（.ihai-simulator）に限定して判定する。
$(function(){
  function cjkConverter(num, irregular = ''){
    var original = num;
    if(num) {
      num = num.replace(/[Ａ-Ｚａ-ｚ０-９]/g,function(s){
           return String.fromCharCode(s.charCodeAt(0)-0xFEE0);
     });
    }
   type = 'place';
   // 元年の元はそのまま返す
   if(num == '元') return num;
   if(irregular == 'gannen' && num == 1) return "元";
    // 0の場合には当を返す
   if(irregular == 'tosai' && num == 0) return "当";

    switch(typeof num){
       case 'number' : num+= '';
       case 'string' : num = num.replace(/\D+/g,'');break;
       default : return false;
   }
   if(type&&type!='each'&&type!='place') return false;
   var cjk_n = ['○','一','二','三','四','五','六','七','八','九'];
   var place = ['零','十','百','千','万','億','兆','京'];
   if(type=='each'||!type||num.length/4>place.length-3){
       return num.replace(/\d/g,s=>cjk_n[parseInt(s)]);
   }
   if(!parseInt(num)) return original;
   var n,str='';
   var arr=num.match(/\d{1,4}?(?=(\d{4})*$)/gm);
   for(var i=0,k=arr.length-1;i<=k;i++){
       if(!parseInt(arr[i])) continue;
       for(var j=0,l=arr[i].length-1;j<=l;j++){
           n=parseInt(arr[i][j]);
           if(!n) continue;
           if(j==l) {
               str+=cjk_n[n];
               continue;
           }
           str+=(n>1?cjk_n[n]:'')+place[l-j];
       }
       if(i!=k) str+=place[k-i+3];
   }
   return str;
 }

function kuridashiIhaiLayout(ihai_layout, index) {
   var ihai_layout_tmp = $.grep(ihai_layout, function(elem){
     return $(elem).hasClass('js-display-page-' + (index + 2)); // MEMO: 2枚目以降のシミュレーションをターゲットにしているため + 2
   });
   return $(ihai_layout_tmp[0]);
}

const simulator = $("#ihai-simulator");

const setOption = function () {
 var ihai_layout = $(".layout1 .pattern1");
 $(".ihai-layout-select").change(function(e){
   var value = $(this).find("select").val();
   var layout_classes = {
     "１名用パターン①": ["layout1", "pattern1"],
     "１名用パターン②（命日裏面）": ["layout1", "pattern2"],
     "俗名位牌": ["layout1", "pattern3"],
     "２名用パターン①": ["layout2", "pattern1"],
     "２名用パターン②": ["layout2", "pattern2"],
     "２名用パターン③（命日裏面）": ["layout2", "pattern3"],
     "２名用俗名位牌": ["layout2", "pattern4"],
     "先祖代々のみ（裏面記載なし）": ["layout3", "pattern1"]
   }
   ihai_layout = $("." + layout_classes[value][0]);
   if($('.ihai-simulator.kuridashi-ihai').length > 0) {
     var elem = $(e.currentTarget);
     var index = $('.ihai-layout-select').index(elem);
     ihai_layout = kuridashiIhaiLayout(ihai_layout, index);
     ihai_layout.removeClass(function(index, className) {
       return (className.match(/\bpattern\S+/g) || []).join(' ');
     });
     ihai_layout.addClass(layout_classes[value][1]);
   } else {
     ihai_layout.removeClass(function(index, className) {
       return (className.match(/\bpattern\S+/g) || []).join(' ');
     });
     ihai_layout.addClass(layout_classes[value][1]);
     $(".ihai-layout").prop('hidden', true);
     ihai_layout.prop('hidden', false);
   }
   
   // 1人用俗名位牌のときには俗名ありなしオプション不要
   if(ihai_layout.hasClass("layout1 pattern3")) {
     $(".js-zokumyo-select").prop("hidden", true);
     $(".js-zokumyo-select").val("");
     $(".js-ihai-zokumyo").html($(".js-ihai-zokumyo").html().replace("俗名&nbsp;", ""));
   } else {
     $(".js-zokumyo-select").prop("hidden", false);
   }    
 });
 
 // 文字入れ人数変更時にレイアウト見本を表示する
 $(".ihai-type").change(function(){
   var layout1_images = ["https://cdn.shopify.com/s/files/1/0569/4459/1035/files/type1_pattern1.png","https://cdn.shopify.com/s/files/1/0569/4459/1035/files/type1_pattern2.png","https://cdn.shopify.com/s/files/1/0569/4459/1035/files/type1_pattern3.png"];
   var layout2_images = ["https://cdn.shopify.com/s/files/1/0569/4459/1035/files/type2_pattern1.png","https://cdn.shopify.com/s/files/1/0569/4459/1035/files/type2_pattern2.png","https://cdn.shopify.com/s/files/1/0569/4459/1035/files/type2_pattern3.png"]
   var layout3_image = "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/type3.png";
   // 板位牌02や繰出位牌では項目名の末尾に識別子が付くため、前方一致で拾う
   var layout_type = $('[name^="properties[文字入れの人数]"]').val();
   if(layout_type.includes("１名")) {
     $(".ihai-layout-select .spb-helptext").html("<img class='ihai-layout-image' src='" + layout1_images[0] +  "''><img class='ihai-layout-image' src='" + layout1_images[1] +  "''><img class='ihai-layout-image' src='" + layout1_images[2] +  "''>");
   } else if(layout_type.includes("２名")) {
       $(".ihai-layout-select .spb-helptext").html("<img class='ihai-layout-image' src='" + layout2_images[0] +  "''><img class='ihai-layout-image' src='" + layout2_images[1] +  "''><img class='ihai-layout-image' src='" + layout2_images[2] +  "''>");
   } else if(layout_type.includes("先祖代々")) {
       $(".ihai-layout-select .spb-helptext").html("<img class='ihai-layout-image' src='" + layout3_image +  "'>");
   }    
 })
 
 // 文字入れ人数の下に先祖代々のレイアウト見本を表示する（繰出位牌）
 var layout3_image = "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/type3.png";
 $(".ihai-type .spb-helptext").html("<img class='ihai-layout-image' src='" + layout3_image +  "'>");

 // 文字色見本画像
 var red_color_image = "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/text_red.png";
 var gold_color_image = "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/text_gold.png";
 $(".ihai-moji-color .spb-helptext").html("<img class='ihai-moji-color-image' src='" + red_color_image +  "''><img class='ihai-moji-color-image' src='" + gold_color_image +  "''>");
 // 文字加工見本画像
 var carve_image = "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/8f56a29f4d4f606117954ebb32845962.jpg?v=1639919543";
 var write_image = "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/4d5da65f0d9f75fac9e9b6acdf1d301c.jpg?v=1639919543";
 $(".ihai-moji-type .spb-helptext").html("<img class='ihai-moji-type-image' src='" + carve_image +  "''><img class='ihai-moji-type-image' src='" + write_image +  "''>");
 
 // 文字色
 $(".ihai-moji-color").change(function(){
   var value = $(this).find("select").val();
   var css_classes = {"表面：金、裏面：金": "gold", "表面：金、裏面：朱": "red"};
   ihai_layout.removeClass("ihai-moji-color-red").removeClass("ihai-moji-color-gold");
   ihai_layout.addClass("ihai-moji-color-" + css_classes[value]);
 });
 
 // 梵字選択
 $(".ihai-bonji input[type='radio']").prop("checked", false);
 $(".ihai-bonji").change(function(){
   ihai_layout.find(".js-ihai-bonji").prop("src", '');
   if($(this).find("input[type='radio']:checked")[0].defaultValue != '不要') {
     var img_url = $(this).find("input[type='radio']:checked").next().css("background-image").split('url("')[1].split('")')[0];
     ihai_layout.find(".js-ihai-bonji").prop("src", img_url);
   }
 });

 // 戒名
 $('[id^=戒名]').not('[id^=戒名（２名分）-]').prop('hidden', true);
 $('[id^=戒名]').not('[id^=戒名（２名分）-]').before('<div class="ihai-input-inline ihai-kaimyo-item"><input type="text" class="js-kaimyo-text"></div>');
 $('.js-kaimyo-text').after('<select class="js-kaimyo-select"><option value="">なし</option><option value="位">位</option></select>');

 // 値置き換え
 const setKaimyo = function(elem) {
   if($('.ihai-simulator.kuridashi-ihai').length > 0) {
     var index = $('[id^=戒名]').index(elem);
     ihai_layout = kuridashiIhaiLayout(ihai_layout, index);
   }
   var kaimyo = elem.parents('.ihai-kaimyo').find('.js-kaimyo-text').val() + elem.parents('.ihai-kaimyo').find('.js-kaimyo-select').val();
   elem.val(kaimyo);
   ihai_layout.find(".js-ihai-kaimyo").html(kaimyo);
 }
 $(document).on('input', '.js-kaimyo-text', function(e) {
   var elem = $(e.currentTarget).parents('.ihai-kaimyo').find('[id^=戒名]');
   setKaimyo(elem);
 });
 $('.js-kaimyo-select').change(function(e){
   var elem = $(e.currentTarget).parents('.ihai-kaimyo').find('[id^=戒名]');
   setKaimyo(elem);
 });

 // 戒名（２名分）
 $('[id^=戒名（２名分）-]').prop('hidden', true);
 $('[id^=戒名（２名分）-]').before('<div class="ihai-input-inline ihai-kaimyo-item"><input type="text" class="js-kaimyo-text-1"><select class="js-kaimyo-select-1"><option value="">なし</option><option value="位">位</option></select><span class="js-kaimyo-sub-1">（夫）</span></div><div class="ihai-input-inline ihai-kaimyo-item"><input type="text" class="js-kaimyo-text-2"><select class="js-kaimyo-select-2"><option value="">なし</option><option value="位">位</option></select><span class="js-kaimyo-sub-2">（妻）</span></div>');
//     $('.js-kaimyo-text-1').after('<select class="js-kaimyo-select-1"><option value="位">位</option><option value="">なし</option></select><span class="js-kaimyo-sub-1">（夫）</span>');
//     $('.js-kaimyo-sub-1').after('</div><div class="ihai-input-inline ihai-kaimyo-item"><input type="text" class="js-kaimyo-text-2">');
//     $('.js-kaimyo-text-2').after('<select class="js-kaimyo-select-2"><option value="位">位</option><option value="">なし</option></select><span class="js-kaimyo-sub-2">（妻）</span></div>');

 // 値置き換え
 kaimyo2Target = $('[id^=戒名（２名分）-]');
 const setKaimyo2 = function(){
   var kaimyo1 =  $('.js-kaimyo-text-1').val() + $('.js-kaimyo-select-1').val();
   var kaimyo2 = $('.js-kaimyo-text-2').val() + $('.js-kaimyo-select-2').val();
   var kaimyo_text = kaimyo1 + '（夫） ' + kaimyo2 + '（妻）';
   kaimyo2Target.val(kaimyo_text);
   ihai_layout.find(".js-ihai-kaimyo-1").html(kaimyo1);
   ihai_layout.find(".js-ihai-kaimyo-2").html(kaimyo2);
 }
 setKaimyo2();
 $(document).on('input', '.js-kaimyo-text-1, .js-kaimyo-text-2', function(e) {
   setKaimyo2();
 });
 $('.js-kaimyo-select-1, .js-kaimyo-select-2').change(function(e){
   setKaimyo2();
 });

 // 没年月日
 $('[id^=没年月日]').not('[id^=没年月日（２名分）-]').prop('hidden', true);
 gengou = '<div class="ihai-input-inline ihai-meinichi-item"><select class="js-meinichi-gengou-select"><option value="令和">令和</option><option value="平成">平成</option><option value="昭和">昭和</option><option value="大正">大正</option><option value="明治">明治</option></select></div>'
 $('[id^=没年月日]').not('[id^=没年月日（２名分）-]').before(gengou);
 year = '<input type="text"size="3" maxlength="2" value="1" class="js-meinichi-year">'
 month = '<input type="text"size="3" maxlength="2" value="1" class="js-meinichi-month">'
 day = '<input type="text"size="3" maxlength="2" value="1" class="js-meinichi-day">'
 $('.js-meinichi-gengou-select').after(year + ' <span class="sub">年</span> ' + month + ' <span class="sub">月</span> ' + day + ' <span class="sub">日 </span>');

 // 値置き換え
 const setMeinichi = function(elem) {
   if($('.ihai-simulator.kuridashi-ihai').length > 0) {
     var index = $('[id^=没年月日]').index(elem);
     ihai_layout = kuridashiIhaiLayout(ihai_layout, index);
   }
   var meinichi = elem.parents('.ihai-meinichi').find('.js-meinichi-gengou-select').val() + cjkConverter(elem.parents('.ihai-meinichi').find('.js-meinichi-year').val(), 'gannen') + '年' + cjkConverter(elem.parents('.ihai-meinichi').find('.js-meinichi-month').val()) + '月' + cjkConverter(elem.parents('.ihai-meinichi').find('.js-meinichi-day').val()) + '日';
   elem.val(meinichi);
   ihai_layout.find(".js-ihai-meinichi").html('<span class="meinich-year">' + elem.parents('.ihai-meinichi').find('.js-meinichi-gengou-select').val() + cjkConverter(elem.parents('.ihai-meinichi').find('.js-meinichi-year').val(), 'gannen') + '年</span>&nbsp;<span class="meinich-detail">' + cjkConverter(elem.parents('.ihai-meinichi').find('.js-meinichi-month').val()) + '月' + cjkConverter(elem.parents('.ihai-meinichi').find('.js-meinichi-day').val()) + '日</span>');
 }

 $(document).on('input', '.js-meinichi-year, .js-meinichi-month, .js-meinichi-day', function(e) {
   var elem = $(e.currentTarget).parents('.ihai-meinichi').find('[id^=没年月日]');
   setMeinichi(elem);
 });
 $('.js-meinichi-gengou-select').change(function(e){
   var elem = $(e.currentTarget).parents('.ihai-meinichi').find('[id^=没年月日]');
   setMeinichi(elem);
 });

 // 没年月日（２名分）
 $('[id^=没年月日（２名分）-]').prop('hidden', true);
 gengou1 = '<div class="ihai-input-inline ihai-meinichi-item js-meinichi-item-1"><select class="js-meinichi-gengou-select-1"><option value="令和">令和</option><option value="平成">平成</option><option value="昭和">昭和</option><option value="大正">大正</option><option value="明治">明治</option><option value="慶応">慶応</option><option value="元治">元治</option><option value="文久">文久</option></select></div>'
 $('[id^=没年月日（２名分）-]').before(gengou1);
 year1 = '<input type="text"size="3" maxlength="2" value="1" class="js-meinichi-year-1">'
 month1 = '<input type="text"size="3" maxlength="2" value="1" class="js-meinichi-month-1">'
 day1 = '<input type="text"size="3" maxlength="2" value="1" class="js-meinichi-day-1">'
 $('.js-meinichi-gengou-select-1').after( year1 + '<span class="sub"> 年</span> ' + month1+ '<span class="sub"> 月 </span>' + day1 + ' <span class="sub">日 （夫）</span>');
 gengou2 = '<div class="ihai-input-inline ihai-meinichi-item"><select class="js-meinichi-gengou-select-2"><option value="令和">令和</option><option value="平成">平成</option><option value="昭和">昭和</option><option value="大正">大正</option><option value="明治">明治</option><option value="慶応">慶応</option><option value="元治">元治</option><option value="文久">文久</option></select></div>'
 $('.js-meinichi-item-1').after(gengou2);
 year2 = '<input type="text"size="3" maxlength="2" value="1" class="js-meinichi-year-2">'
 month2 = '<input type="text"size="3" maxlength="2" value="1" class="js-meinichi-month-2">'
 day2 = '<input type="text"size="3" maxlength="2" value="1" class="js-meinichi-day-2">'
 $('.js-meinichi-gengou-select-2').after(year2 + '<span class="sub"> 年</span> ' + month2+ '<span class="sub"> 月</span> ' + day2 + '<span class="sub"> 日 （妻）</span>');


 // 値置き換え
 meinichi2Target = $('[id^=没年月日（２名分）-]');
 const setMeinichi2 = function() {
   var meinichi1 = $('.js-meinichi-gengou-select-1').val() + cjkConverter($('.js-meinichi-year-1').val(), 'gannen') + '年 ' + cjkConverter($('.js-meinichi-month-1').val()) + '月 ' + cjkConverter($('.js-meinichi-day-1').val()) + '日';
   var meinichi2 = $('.js-meinichi-gengou-select-2').val() + cjkConverter($('.js-meinichi-year-2').val(), 'gannen') + '年 ' + cjkConverter($('.js-meinichi-month-2').val()) + '月 ' + cjkConverter($('.js-meinichi-day-2').val()) + '日';
   var meinichi_text = meinichi1 + '（夫） ' + meinichi2 + '（妻）';
   meinichi2Target.val(meinichi_text);
   ihai_layout.find(".js-ihai-meinichi-1").html(meinichi1);
   ihai_layout.find(".js-ihai-meinichi-2").html(meinichi2);
 }

 setMeinichi2();
 $(document).on('input', '.js-meinichi-year-1, .js-meinichi-month-1, .js-meinichi-day-1,.js-meinichi-year-2, .js-meinichi-month-2, .js-meinichi-day-2', function(e) {
   setMeinichi2();
 });
 $('.js-meinichi-gengou-select-1, .js-meinichi-gengou-select-2').change(function(e){
   setMeinichi2();
 });

 // 俗名
 $('[id^=俗名]').not('[id^=俗名（２名分）-]').prop('hidden', true);
 zokumyo = '<div class="ihai-input-inline ihai-zokumyo-item"><select class="js-zokumyo-select"><option value="俗名">俗名有り</option><option value="">俗名なし</option></select></div>'
 $('[id^=俗名]').not('[id^=俗名（２名分）-]').before(zokumyo);
 sei = '<input type="text" size="8" maxlength="6" value="姓" class="js-zokumyo-sei" onblur="if (this.value == ' + "''" + ') this.value = ' + "'姓'" + ';" onfocus="if (this.value == ' + "'姓'" + ') this.value = ' + "''" + ';">'
 mei = '<input type="text" size="8" maxlength="6" value="名" class="js-zokumyo-mei" onblur="if (this.value == ' + "''" + ') this.value = ' + "'名'" + ';" onfocus="if (this.value == ' + "'名'" + ') this.value = ' + "''" + ';">'
 $('.js-zokumyo-select').after(sei + mei);

 // 値置き換え
 const setZokumyo = function(elem) {
   if($('.ihai-simulator.kuridashi-ihai').length > 0) {
     var index = $('[id^=俗名]').index(elem);
     ihai_layout = kuridashiIhaiLayout(ihai_layout, index);
   }
   var zokumyo = elem.parents('.ihai-zokumyo').find('.js-zokumyo-select').val() + elem.parents('.ihai-zokumyo').find('.js-zokumyo-sei').val() + '  ' + elem.parents('.ihai-zokumyo').find('.js-zokumyo-mei').val();
   elem.val(zokumyo);
   ihai_layout.find(".js-ihai-zokumyo").html(elem.parents('.ihai-zokumyo').find('.js-zokumyo-select').val() + '&nbsp;' + elem.parents('.ihai-zokumyo').find('.js-zokumyo-sei').val() + '  ' + elem.parents('.ihai-zokumyo').find('.js-zokumyo-mei').val());            
 }

 $(document).on('input', '.js-zokumyo-sei, .js-zokumyo-mei', function(e) {
   var elem = $(e.currentTarget).parents('.ihai-zokumyo').find('[id^=俗名]');
   setZokumyo(elem);
 });
 $('.js-zokumyo-select').change(function(e){
   var elem = $(e.currentTarget).parents('.ihai-zokumyo').find('[id^=俗名]');
   setZokumyo(elem);
 });

 // 俗名（２名分）
 $('[id^=俗名（２名分）-]').prop('hidden', true);
 zokumyo1 = '<div class="ihai-input-inline ihai-zokumyo-item js-zokumyo-input-1"><select class="js-zokumyo-select-1"><option value="俗名">俗名有り</option><option value="">俗名なし</option></select></div>'
 $('[id^=俗名（２名分）-]').before(zokumyo1);
 sei1 = '<input type="text" size="8" maxlength="6" value="姓" class="js-zokumyo-sei-1" onblur="if (this.value == ' + "''" + ') this.value = ' + "'姓'" + ';" onfocus="if (this.value == ' + "'姓'" + ') this.value = ' + "''" + ';">'
 mei1 = '<input type="text" size="8" maxlength="6" value="名" class="js-zokumyo-mei-1" onblur="if (this.value == ' + "''" + ') this.value = ' + "'名'" + ';" onfocus="if (this.value == ' + "'名'" + ') this.value = ' + "''" + ';">'
 $('.js-zokumyo-select-1').after(sei1 + mei1 + '<span class="js-zokumyo-sub-1">（夫）</span>');
 zokumyo2 = '<div class="ihai-input-inline ihai-zokumyo-item"><select class="js-zokumyo-select-2"><option value="俗名">俗名有り</option><option value="">俗名なし</option></select></div>'
 $('.js-zokumyo-input-1').after(zokumyo2);
 sei2 = '<input type="text" size="8" maxlength="6" value="姓" class="js-zokumyo-sei-2" onblur="if (this.value == ' + "''" + ') this.value = ' + "'姓'" + ';" onfocus="if (this.value == ' + "'姓'" + ') this.value = ' + "''" + ';">'
 mei2 = '<input type="text" size="8" maxlength="6" value="名" class="js-zokumyo-mei-2" onblur="if (this.value == ' + "''" + ') this.value = ' + "'名'" + ';" onfocus="if (this.value == ' + "'名'" + ') this.value = ' + "''" + ';">'
 $('.js-zokumyo-select-2').after(sei2 + mei2 + '<span class="js-zokumyo-sub-2">（妻）</span>');

 // 値置き換え
 zokumyo2Target = $('[id^=俗名（２名分）-]');
 const setZokumyo2 = function() {
   var zokumyo1_html = '<span class="zokumyo-title">' + $('.js-zokumyo-select-1').val() + '</span>&nbsp;' + $('.js-zokumyo-sei-1').val() + '  ' + $('.js-zokumyo-mei-1').val();
   var zokumyo2_html = '<span class="zokumyo-title">' + $('.js-zokumyo-select-2').val() + '</span>&nbsp;' + $('.js-zokumyo-sei-2').val() + '  ' + $('.js-zokumyo-mei-2').val();
   var zokumyo1_text = $('.js-zokumyo-select-1').val() +  $('.js-zokumyo-sei-1').val() + '  ' + $('.js-zokumyo-mei-1').val();
   var zokumyo2_text = $('.js-zokumyo-select-2').val() + $('.js-zokumyo-sei-2').val() + '  ' + $('.js-zokumyo-mei-2').val();
   var zokumyo_text = zokumyo1_text + '（夫） ' + zokumyo2_text + '（妻）';

   zokumyo2Target.val(zokumyo_text);
   ihai_layout.find(".js-ihai-zokumyo-1").html(zokumyo1_html);
   ihai_layout.find(".js-ihai-zokumyo-2").html(zokumyo2_html);
 }

 setZokumyo2();
 $(document).on('input', '.js-zokumyo-sei-1, .js-zokumyo-mei-1, .js-zokumyo-sei-2, .js-zokumyo-mei-2', function(e) {
   setZokumyo2();
 });
 $('.js-zokumyo-select-1, .js-zokumyo-select-2').change(function(e){
   setZokumyo2();
 });

 // 没年齢
 $('[id^=没年齢]').not('[id^=没年齢（２名分）-]').prop('hidden', true);
 $('[id^=没年齢]').not('[id^=没年齢（２名分）-]').before('<div class="ihai-input-inline ihai-kyonen-item"><select class="js-kyonen-select1"><option value="行年">行年</option><option value="享年">享年</option><option value="">なし</option></select></div>');
 $('.js-kyonen-select1').after('<input type="text" size="3" maxlength="3" class="js-kyonen-age">');
 $('.js-kyonen-age').after('<select class="js-kyonen-select2"><option value="歳">歳</option><option value="才">才</option></select>');

 // 値置き換え
 const setKyonen = function(elem) {
   if($('.ihai-simulator.kuridashi-ihai').length > 0) {
     var index = $('[id^=没年齢]').index(elem);
     ihai_layout = kuridashiIhaiLayout(ihai_layout, index);
   }
   var kyonen_html = elem.parents('.ihai-kyonen').find('.js-kyonen-select1').val() + '&nbsp;&nbsp;' + cjkConverter(elem.parents('.ihai-kyonen').find('.js-kyonen-age').val()) + elem.parents('.ihai-kyonen').find('.js-kyonen-select2').val();
   var kyonen = elem.parents('.ihai-kyonen').find('.js-kyonen-select1').val() + cjkConverter(elem.parents('.ihai-kyonen').find('.js-kyonen-age').val(), 'tosai') + elem.parents('.ihai-kyonen').find('.js-kyonen-select2').val();
   elem.val(kyonen);
   ihai_layout.find(".js-ihai-kyonen").html(kyonen);
 }

 $(document).on('input', '.js-kyonen-age', function(e) {
   var elem = $(e.currentTarget).parents('.ihai-kyonen').find('[id^=没年齢]');
   setKyonen(elem);
 });
 $('.js-kyonen-select1, .js-kyonen-select2').change(function(e){
   var elem = $(e.currentTarget).parents('.ihai-kyonen').find('[id^=没年齢]');
   setKyonen(elem);
 });

 // 没年齢（２名分）
 $('[id^=没年齢（２名分）-]').prop('hidden', true);
 $('[id^=没年齢（２名分）-]').before('<div class="ihai-input-inline ihai-kyonen-item js-kyonen-item-1"><select class="js-kyonen-select1-1"><option value="行年">行年</option><option value="享年">享年</option><option value="">なし</option></select></div>');
 $('.js-kyonen-select1-1').after('<input type="text" size="3" maxlength="3" class="js-kyonen-age-1">');
 $('.js-kyonen-age-1').after('<select class="js-kyonen-select2-1"><option value="歳">歳</option><option value="才">才</option></select><span class="js-kyonen-sub-1">（夫）</span>');
 $('.js-kyonen-item-1').after('<div class="ihai-input-inline ihai-kyonen-item"><select class="js-kyonen-select1-2"><option value="行年">行年</option><option value="享年">享年</option><option value="">なし</option></select></div>');
 $('.js-kyonen-select1-2').after('<input type="text" size="3" maxlength="3" class="js-kyonen-age-2">');
 $('.js-kyonen-age-2').after('<select class="js-kyonen-select2-2"><option value="歳">歳</option><option value="才">才</option></select><span class="js-kyonen-sub-1">（妻）</span>');

 // 値置き換え
 kyonen2Target = $('[id^=没年齢（２名分）-]');
 const setKyonen2 = function() {
   var kyonen1 = $('.js-kyonen-select1-1').val() + cjkConverter($('.js-kyonen-age-1').val(), 'tosai') + $('.js-kyonen-select2-1').val();
   var kyonen2 = $('.js-kyonen-select1-2').val() + cjkConverter($('.js-kyonen-age-2').val(), 'tosai') + $('.js-kyonen-select2-2').val();
   var kyonen_text = kyonen1 + '（夫） ' + kyonen2 + '（妻）';

   kyonen2Target.val(kyonen_text);
   ihai_layout.find(".js-ihai-kyonen-1").html(kyonen1);
   ihai_layout.find(".js-ihai-kyonen-2").html(kyonen2);
 }

 setKyonen2();
 $(document).on('input', '.js-kyonen-age-1, .js-kyonen-age-2', function(e) {
   setKyonen2();
 });
 $('.js-kyonen-select1-1, .js-kyonen-select1-2, .js-kyonen-select2-1, .js-kyonen-select2-2').change(function(e){
   setKyonen2();
 });

 // 家の姓
 $('[id^=家の姓]').prop('hidden', true);
 $('[id^=家の姓]').before('<div class="ihai-input-inline ihai-sei-item"><input type="text" size="8" maxlength="6" class="js-sei"></div>');
 sei = '<select class="js-zokumyo-select"><option value="">▼お選び下さい</option><option value="俗名有り">俗名有り</option><option value="俗名なし">俗名なし</option></select>'
 $('.js-sei').after('<select class="js-sei-select"><option value="">▼お選び下さい</option><option value="家先祖代々之位">家先祖代々之位</option><option value="家先祖代々之霊位">家先祖代々之霊位</option></select>');

 // 値置き換え
 seiTarget = $('[id^=家の姓]');
 const setSei = function() {
   if($('.ihai-simulator.kuridashi-ihai').length > 0) {
     ihai_layout = $(".ihai-layout.js-display-page-1");
   }
   var sei = $('.js-sei').val() + $('.js-sei-select').val();
   seiTarget.val(sei);
   ihai_layout.find(".js-ihai-sei").html(sei);
 }

 setSei();
 $(document).on('input', '.js-sei', function(e) {
   setSei();
 });
 $('.js-sei-select').change(function(e){
   setSei();
 });
 
 // 注意文字の画像配置
 var moji_images = [
     { name: "釈Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/56b5032415ecc12fbda81ef0fb905c3e.png?v=1638815637" },
     { name: "釈Ｂ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/e9737ab8f876d338332047e20710f9b4.png?v=1638815637" },
     { name: "誉Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/40750d06de8066fe2927e2dd9ffc6705.png?v=1638815637" },
     { name: "誉Ｂ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/c96df9fa455656caa1357e4ec1e701e4.png?v=1638815637" },
     { name: "寿Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/C.png?v=1638815638" },
     { name: "寿Ｂ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/B.png?v=1638815637" },
     { name: "寿Ｃ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/88401c026b8f1a23c245581c3bc11143.png?v=1638815638" },
     { name: "徳Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/bbd30fe31bb62c8c31e70c85b9ee0f4d.png?v=1638815637" },
     { name: "学Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/80ab4e0bdf8464564550b2262adc21fe.png?v=1638815637" },
     { name: "栄Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/f334b4452a31f04ee5c000a60056bbef.png?v=1638815637" },
     { name: "実Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/9ac1e5b88c80fd74de7dae42b77dc010.png?v=1638815637" },
     { name: "真Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/7a4f6d0a68511df065d34ecc1be9d3c9.png?v=1638815637" },
     { name: "宝Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/eea79eef6fb0cf7ac0578d0498a9ebc7.png?v=1638815637" },
     { name: "静Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/47526113f7dfa1882c195971ab73e19d.png?v=1638815637" },
     { name: "静Ｂ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/ed2228d0e89c382c874385cadc49698f.png?v=1638815637" },
     { name: "高Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/1d1a69c0e028c8d31cfb84f9f9a66efb.png?v=1638815637" },
     { name: "崎Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/8ef66ac419ee184767e6485548fa62bc.png?v=1638815637" },
     { name: "崎Ｂ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/ec74fd84ab6eafb85ef7484d3765b04e.png?v=1638815637" },
     { name: "吉Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/6c49eb942166915ce99d923b47e35acf.png?v=1638815637" },
     { name: "廣Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/f259cc1e84e590256e5c0bc55b54df05.png?v=1638815638" },
     { name: "邉Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/1ba813961b3c4c43408a864afbc80d1f.png?v=1638815637" },
     { name: "邉B", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/e874f6c2f7d6abc6c53748e29e9c1e87.png?v=1638815638" },
     { name: "邉C", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/c83e34728e1a69ec184da1f64d71c1d8.png?v=1638815638" },
     { name: "邉D", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/74d7d320814787b2111543fdec38d573.png?v=1638815638" },
     { name: "邊Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/4255c99188b2edd629e96a4ba93d8ee6.png?v=1638815637" },
     { name: "邊Ｂ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/d7fba25cc1bd92cc03a17c65fb894cc2.png?v=1638815637" },
     { name: "邊Ｃ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/f97a2b449b7d37f0d77fcf220b720742.png?v=1638815638" },
     { name: "邊Ｄ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/87f52224139ff88b2bd99dba1b0f311d.png?v=1638815638" },
     { name: "柳Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/bc8b764fa138b23d9cbc7247e889c5ca.png?v=1638815638" },
     { name: "恵Ａ", src: "https://cdn.shopify.com/s/files/1/0569/4459/1035/files/4e8d63cd0c72f2fdab690bb66cd27e02.png?v=1638815638" }
   ]
 var moji_images_html = '';
 $.each(moji_images, function(index, data){  
   moji_images_html = moji_images_html + "<div class='ihai-moji-item'><span>"+data["name"]+"</span><img src="+ data["src"] + "></div>"
 })
 $(".spb-helptext:contains('注意文字画像')").html("旧字、異体字等がある場合は、以下よりご指定ください。<br><div class='ihai-moji-list'>" + moji_images_html + "</div>");
 
 // FAX用紙のリンク置き換え
 $(".spb-helptext:contains('FAX用紙はこちらからダウンロードしてください。')").html("FAX用紙は<a href='https://cdn.shopify.com/s/files/1/0569/4459/1035/files/FAX_9a8edcc4-cc2b-433e-826c-8a2f0f978ca0.pdf?v=1635430845' target='_blank'>こちら</a>からダウンロードしてください。");

 // FAXで送信する場合、シミュレータを非表示にする
 $(".ihai-fax-require input").click(function(){
   if($(".ihai-fax-require input").val() != '') {
     $(".ihai-simulator-display").css("opacity", "1");
   } else {
     $(".ihai-simulator-display").css("opacity", "0");
   }
 })
 
 // 必須ラベルつける
 $("label.productdescfont :contains('梵字')").append("<span class='require'>必須</span>");
 $("label:contains('お位牌作成にあたっての注意事項')").append("<span class='require'>必須</span>");
 
 
   // Enterキー無効化
 $("input").on("keydown", function(e) {
   if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
     return false;
   } else {
     return true;
   }
 });
 
 // ヘルプテキストを必要があれば改行
 $(".spb-helptext:contains(',')").each(function(){
   var text = $(this).html().split(',').join('<br>');
   $(this).html(text);
 })
 
 
 // TODO: 項目名の先頭に番号をつける
//   $("#infiniteoptions-container > div:visible label.spb-productdescfont").prepend("a")
 
}

 var option_setting = false;
 $(".js-ihai-modal-trigger").click(function(){
   if(!option_setting) {
     setOption();
     option_setting = true;
   }
 })
 
})
